import {NumberCol, RenderStringCol, RenderStringCol2, StringCol, Table, ViewOnly} from "../../../../misc/scroller/Table";
import {MiscProduct} from "../../../../api/MiscProducts";
import {getAll} from "../../../logistics/routes/useGetAll";
import {useProjectId} from "../ProjectName";
import {useMiscProductApi} from "./misc/MiscProductAPI";
import {useAlternative} from "../../quote/alternative/Alternative";
import {AddItemDialog} from "./misc/AddItemDialog";
import {removeRowOption, RowOptionCol} from "../../../logistics/purchasing/RowOptions";
import {decorate} from "../../../../misc/pdf/parts/CoverPage";
import {useContext} from "react";
import {ChangePreviewContext} from "../ShopDrawingChangePreview";
import {Checkbox2Col} from "../ShopTableCol";
import {useIsQuote} from "../../quote/QuoteContainer";
import {MiscProductLogiCtrlCell} from "./misc/MiscProductLogiCtrl";
import {ProjectPageTitle} from "../ProjectPageTitle";

export function HardwareMisc() {

    const project = useProjectId();
    const alt = useAlternative();
    const papi = useMiscProductApi()
    const previewCtx = useContext(ChangePreviewContext);
    const previewId = previewCtx.enabled ? previewCtx.sessionId : undefined;

    const isQuote = useIsQuote();
    const tableName = `misc-hardware.${project}-${alt}`;

    return (
        <>
            <ProjectPageTitle title="Misc Hardware" />
            <Table<MiscProduct>
                name={tableName}
                columns={[
                    RowOptionCol({
                        options: dt => {
                            return [
                                removeRowOption(dt, {
                                    refreshTables: [tableName],
                                })
                            ];
                        }
                    }),
                    RenderStringCol<MiscProduct>("#", dt => dt.id.toString(), 50),
                    !isQuote && RenderStringCol2<MiscProduct>("Status", () => "", dt => {
                        if(!dt.logictrl) return null;
                        return <MiscProductLogiCtrlCell miscProduct={dt.id} status={dt.logictrl} />
                    }),
                    ViewOnly(StringCol("Category", "categoryName")),
                    ViewOnly(StringCol("Code", "productCode")),
                    ViewOnly(StringCol("Finish", "finishCode")),
                    Checkbox2Col<MiscProduct>("Keyed", "keyed", {
                        disabled: input => !input.productKeyed,
                    }),
                    {
                        name: "Dim.",
                        render: dt => [
                            decorate(dt.dimHeight, "", "H"),
                            decorate(dt.dimWidth, "", "W"),
                            decorate(dt.dimLength, "", "L"),
                        ].filter(v => !!v).join(" x ")
                    },
                    NumberCol("Qty", "qty"),
                    StringCol("Notes", "note"),
                ]}
                fetch={(ctx) => getAll(ctx, offset => papi.list({
                    offset,
                    project: project,
                    alternative: alt,
                    previewChangeset: previewId,
                }))}
                fetchDeps={[project, papi, previewId, isQuote]}
                onChange={input => papi.upsert(input)}
                insert={{
                    alignX: "left",
                    modal(onDone: () => {}): any {
                        return <AddItemDialog onDone={onDone} />
                    }
                }}
            />

        </>
    )
}